// extracted by mini-css-extract-plugin
export default {"sideBarHeader":"SideBar_sideBarHeader__x8lZp","sideBarUser":"SideBar_sideBarUser__RlHTw"};